// Column definitions for the Achievement Badges GlobalTable.
// Field names match the LIST endpoint response (see public/achievement-badges-api.md).
import { resolveBadgeImage } from './resolveBadgeImage';

export const AchievementBadgeTableHeader = () => [
  { field: 'sl_no', headerName: 'Sl No', width: 90 },
  { field: 'badge_id', headerName: 'Badge Id', width: 110 },
  {
    field: 'badge_image',
    headerName: 'Image',
    width: 110,
    renderCell: (params) => {
      const src = resolveBadgeImage(params.value);
      return src ? (
        <img
          src={src}
          alt={params.row.badge_name || 'badge'}
          style={{ width: 40, height: 40, objectFit: 'contain', borderRadius: 6 }}
        />
      ) : (
        '-'
      );
    },
  },
  { field: 'badge_name', headerName: 'Badge Name', width: 260, toolTipGetter: true },
  { field: 'badge_description', headerName: 'Description', width: 360, toolTipGetter: true },
  {
    field: 'course_name',
    headerName: 'Course',
    width: 220,
    renderCell: (params) => params.row?.course_name || '-',
    toolTipGetter: true,
  },
  {
    field: 'assignment_name',
    headerName: 'Assignment',
    width: 240,
    renderCell: (params) => params.row?.assignment_name || '-',
    toolTipGetter: true,
  },
  {
    field: 'createdByName',
    headerName: 'Created By',
    width: 180,
    renderCell: (params) => params.row?.created_user?.name || '-',
    toolTipGetter: true,
  },
  { field: 'created_on', headerName: 'Created On', width: 190, toolTipGetter: true },
  {
    field: 'edit',
    headerName: 'Edit',
    type: 'action',
    actionType: 'edit',
    actionKey: 'editBadge',
    width: 140,
    buttonName: 'Edit',
  },
  {
    field: 'delete',
    headerName: 'Delete',
    type: 'action',
    actionType: 'delete',
    actionKey: 'deleteBadge',
    width: 150,
    buttonName: 'Delete',
  },
];
